import '../styles/pages/impressum.css'



function Impressum() {
    return (
        <div className="impressum-container">
            <h1>Impressum</h1>

            <div className="section">
                <strong>Angaben gemäß § 5 TMG:</strong><br />
                Nurleder.de<br />
                <br />

            </div>

            <div className="section">
                <strong>Kontakt:</strong><br />
                Telefon: 📱 +49 151 6155 9999<br />
                E-Mail: <a href="mailto:info@nurleder.de">info@nurleder.de</a><br />
                Website: <a href="https://www.nurleder.de" target="_blank" rel="noopener noreferrer">www.nurleder.de</a>
            </div>

            <div className="section">
                <strong>Steuer-ID:</strong><br />
                Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:<br />
                DE448325772
            </div>

            <div className="section">
                <strong>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</strong><br />


            </div>

            <div className="section">
                <strong>Online-Streitbeilegung:</strong><br />
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:<br />
                <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
                    https://ec.europa.eu/consumers/odr
                </a>
            </div>

            <div className="section">
                <strong>Haftungsausschluss:</strong><br />
                Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links.
                Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
            </div>
        </div>
    );
}

export default Impressum;
